import ViewViewModel from '@/ViewModels/ViewViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';

import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import PanelBarViewModelT from '@/ViewModels/Controls/PanelBarViewModel';
import PanelBarItemViewModelT from '@/ViewModels/Controls/PanelBarItemViewModel';
import TreeViewViewModelT from '@/ViewModels/Controls/TreeViewViewModel';

export default class NavigationViewModel extends ViewViewModel {

    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
    private PanelBarViewModel = ComponentManager.getViewModel<typeof PanelBarViewModelT>('PanelBarViewModel');
    private PanelBarItemViewModel = ComponentManager.getViewModel<typeof PanelBarItemViewModelT>('PanelBarItemViewModel');
    private TreeViewViewModel = ComponentManager.getViewModel<typeof TreeViewViewModelT>('TreeViewViewModel');

    /**
     * Definiert die PanelBar in der Navigation
     */
    public panelBar: PanelBarViewModelT;

    public constructor(params: CoreFrameInterfaces.NavigationViewModelConstructorParameter) {
        super(params);

        let treeViewViewModel = TreeViewViewModelT.parseUserNavigationTree(this.locator);

        let panelBarItemViewModel = new this.PanelBarItemViewModel({
            parentLocator: this.locator,
            locator: 'navigation-panel',
            isExpanded: true,
            isSelected: false,
            hasFullHeight: true,
            treeView: treeViewViewModel
        });

        let panelBarItemViewModels = [panelBarItemViewModel];

        this.panelBar = new this.PanelBarViewModel({ items: panelBarItemViewModels });
    }
}

ComponentManager.setViewModel('LegacyNavigationViewModel', NavigationViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');